module.exports = {
    DELETE_DESIGNATION: "Are you sure you want to delete this designation?",
}